import React from "react";
import { Button } from "react-bootstrap";
import { FaFileAlt, FaFilePdf, FaFileImage, FaDownload, FaTrash, FaEye } from "react-icons/fa";
import { getFileUrl } from "../../../api";

const FilePreview = ({ file, onRemove, label }) => {
 if (!file) return null;

 const isNewFile = file instanceof File;
 const isString = typeof file === 'string';
 
 let fileName = "Document";
 let fileUrl = "";

 if (isNewFile) {
 fileName = file.name;
 fileUrl = URL.createObjectURL(file);
 } else if (isString) {
 fileUrl = file;
 fileName = file.split('/').pop().split('?')[0] || "Document";
 } else {
 // It's an object { fileName, fileUrl, filePath, url, name }
 fileName = file.fileName || file.name || file.originalName || "Document";
 fileUrl = file.fileUrl || file.url || file.filePath || "";
 }
 
 // Use centralized helper
 if (fileUrl && !isNewFile) {
 fileUrl = getFileUrl(fileUrl);
 }
 
 if (!fileUrl) return null;
 
 const getFileIcon = (name) => {
 const ext = name?.split('.').pop().toLowerCase();
 if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return <FaFileImage />;
 if (ext === 'pdf') return <FaFilePdf />;
 return <FaFileAlt />;
 };

 const isImage = (name) => {
 const ext = name?.split('.').pop().toLowerCase();
 return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
 };

 const handleDownload = async (e) => {
   e.preventDefault();
   e.stopPropagation();
   try {
     const res = await fetch(fileUrl);
     if (!res.ok) throw new Error("Download failed");
     const blob = await res.blob();
     const url = window.URL.createObjectURL(blob);
     const a = document.createElement("a");
     a.href = url;
     a.download = fileName || "Document";
     document.body.appendChild(a);
     a.click();
     document.body.removeChild(a);
     window.URL.revokeObjectURL(url);
   } catch (_) {
     const a = document.createElement("a");
     a.href = fileUrl;
     a.download = fileName || "Document";
     a.target = "_blank";
     document.body.appendChild(a);
     a.click();
     document.body.removeChild(a);
   }
 };

 return (
 <div className="mt-2 p-2 border rounded d-flex align-items-center justify-content-between bg-light" style={{ minWidth: '200px' }}>
 <div className="d-flex align-items-center overflow-hidden">
 <div className="me-2 text-primary fs-4">
 {getFileIcon(fileName)}
 </div>
 <div className="overflow-hidden">
 <div className="text-truncate fw-bold" style={{ maxWidth: '180px' }} title={fileName}>
 {fileName}
 </div>
 {label && <small className="text-muted d-block">{label}</small>}
 </div>
 </div>
 
 <div className="d-flex gap-1 ms-2">
 {/* Preview Button (Eye) */}
 {fileUrl && (
 <a 
 href={fileUrl}
 target="_blank"
 rel="noopener noreferrer"
 className="btn btn-outline-info btn-sm p-1 px-2 border-0 shadow-none"
 title="Preview"
 >
 <FaEye />
 </a>
 )}
 
 {/* Download Button (Only for existing files) */}
 {!isNewFile && fileUrl && (
 <button 
 type="button"
 onClick={handleDownload}
 className="btn btn-outline-success btn-sm p-1 px-2 border-0 shadow-none"
 title="Download"
 >
 <FaDownload />
 </button>
 )}

 {/* Delete Button */}
 {onRemove && (
 <Button 
 variant="outline-danger" 
 size="sm" 
 className="p-1 px-2 border-0 shadow-none"
 onClick={onRemove}
 title="Remove"
 >
 <FaTrash />
 </Button>
 )}
 </div>
 </div>
 );
};

export default FilePreview;
